/**
 * 路由追踪中间件组件
 *
 * 在React Router中集成用户追踪系统
 * 监听路由变化，自动调用tracking.updateRoute()
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackingService } from '@/services/tracking';

/**
 * 追踪中间件 - 监听路由变化并记录
 *
 * 使用说明：
 * 在App组件中使用此组件，确保它在路由定义之前渲染
 *
 * 示例：在App组件中添加 <TrackingMiddleware />
 */
export function TrackingMiddleware() {
  const location = useLocation();

  useEffect(() => {
    // 当路由变化时，调用tracking.updateRoute()
    // 这样可以：
    // 1. 计算前一个路由的停留时长
    // 2. 如果停留 >= 2秒且不重复，发送访问记录
    // 3. 创建新的路由会话

    console.log('[TrackingMiddleware] Route changed:', {
      pathname: location.pathname,
      search: location.search,
    });

    trackingService.updateRoute(
      location.pathname + location.search,
      document.title,
      document.referrer
    );
  }, [location.pathname, location.search]);

  // 此组件不渲染任何UI
  return null;
}

export default TrackingMiddleware;
